import React, { useEffect, useState } from 'react';
import { 
  Container, 
  Row,
  Table,
  Col, 
  Image, 
  Form, 
  Button, 
  Dropdown, 
  DropdownButton, 
  Pagination 
} from 'react-bootstrap';
import Connection from '../../../Calls';
import Backend from '../../../Backend';
import "./TransactionsComponent.css"

const TransactionComponent = (props) => {
  const [transactionsList, setTransactionList] = useState([]);
  const [numberBy, setNumberBy] = useState(25);
  const [currentPage, setCurrentPage] = useState(1);
  const [order, setOrder] = useState("");
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");
  const [search, setSearch] = useState("");
  const [dataLength, setDataLength] = useState("");
  

  useEffect(() => {
    getTransactions(currentPage, numberBy, order);
  },[])

  useEffect(() => {
    setOrder(props.traductions.General.filtros.title_filter)
  },[props.traductions])

  const EZcga8qH = () => {
    let value, date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XCHF101"), latitude = "0", longitude = "0";
    navigator.geolocation.getCurrentPosition((success, error, options) => {
      latitude = success.coords.latitude;
      longitude = success.coords.longitude
    });
    result = latitude + longitude;
    Connection.EZcga8qH(confirmation, date, result, "XL7FefG", combination, "XCHF101", response => {
      value = response.payload.r01;
    });
    return value;
  }

  
  const getTransactions = (page, dataPerPage, value_orderbyfilter) => {
    let dateInit = "";
    let dateFinal = "";
    setCurrentPage(page);
    setNumberBy(dataPerPage);

    if (dateFrom !== "") {
      dateInit = dateFrom + ' 00:00:00';
    }
    if (dateTo !== "") {
      dateFinal = dateTo + ' 23:59:59';
    }
    let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XCHF101"), latitude = "0", longitude = "0";
    navigator.geolocation.getCurrentPosition((success, error, options) => {
      latitude = success.coords.latitude;
      longitude = success.coords.longitude
    });
    result = latitude + longitude;
    Connection.EZcga8qH(confirmation, date, result, "XL7FefG", combination, "XCHF101", response => {
      Backend.TransactionsVirtualExchange(localStorage.getItem('email'), localStorage.getItem('token'), dataPerPage, page, search, dateInit, dateFinal, value_orderbyfilter, response.payload.r01, response => {
        setTransactionList(response.payload.transactions_list)
        setDataLength(Math.ceil(response.payload.total_amount / dataPerPage)) 
      })
    })
  }

  const renderListTransactions = () => {
    let list = [];
    if (transactionsList && transactionsList.length > 0) {
      transactionsList.forEach((row, index) => {
        let coin = row.pair.split("/")[0].toLowerCase();
        list.push(
          <tr key={index + 1}>
            <td className="data-transactions"><Image src={require("../../../CryptoIcons/" + coin + ".svg")} className="icon-crypto-svg" /> {row.pair}</td>
            <td className="data-transactions">{row.wallet_alias}</td>
            <td className="data-transactions" style={(row.category === "buy") ? { color: "#4EC95E", textTransform: "capitalize", textAlign: "center"} : { textAlign: "center", color: "#FB5B5A", textTransform: "capitalize" }}>{row.category}</td>
            <td className="data-transactions">{row.amount}</td>
            <td className="data-transactions">{row.price}</td>
            <td className="data-transactions">{row.status}</td>
            <td className="data-transactions">{row.date}</td>
          </tr>
        );
      });
    }
    return list;
  }

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      setSearch([])
      getTransactions(1, numberBy, search);
    }
  }

  const changePage = (value) => {
    setCurrentPage(value)
    getTransactions(value, numberBy, order);
  }

  return (
    <>
    <Row style={{padding: '10px'}}>
      <Col xl={4}>
      <Form.Label className="virtual_exchange_information_wallets_text">{props.traductions.VEX.transacciones.L_sort}:</Form.Label>
        <DropdownButton id="filter" title={order}>
          <Dropdown.Item onClick={() => { setOrder( props.traductions.General.filtros.Date_newest ); getTransactions(1, 25, "date_new"); }} as="button">{props.traductions.General.filtros.Date_newest}</Dropdown.Item>
          <Dropdown.Item onClick={() => { setOrder( props.traductions.General.filtros.Date_older ); getTransactions(1, 25, "date_old"); }} as="button">{props.traductions.General.filtros.Date_older}</Dropdown.Item>
          <Dropdown.Item onClick={() => { setOrder( props.traductions.General.filtros.Amount_lower ); getTransactions(1, 25, "amount_low"); }} as="button">{props.traductions.General.filtros.Amount_lower}</Dropdown.Item>
          <Dropdown.Item onClick={() => { setOrder( props.traductions.General.filtros.Amount_bigger ); getTransactions(1, 25, "amount_big"); }} as="button">{props.traductions.General.filtros.Amount_bigger}</Dropdown.Item>
          <Dropdown.Item onClick={() => { setOrder( props.traductions.General.filtros.Category_received ); getTransactions(1, 25, "cat_rcvd"); }} as="button">{props.traductions.General.filtros.Category_received}</Dropdown.Item>
          <Dropdown.Item onClick={() => { setOrder( props.traductions.General.filtros.Category_withdrawal ); getTransactions(1, 25, "cat_with"); }} as="button">{props.traductions.General.filtros.Category_withdrawal}</Dropdown.Item>
        </DropdownButton>
      </Col>
      <Col xl={4}>
        <Form.Label className="virtual_exchange_information_wallets_text">{props.traductions.VEX.transacciones.L_dateF}:</Form.Label>
        <Form.Control
          type="date"
          
          value={dateFrom}
          onChange={(e) => setDateFrom(e.target.value) }
        />
      </Col>
      <Col xl={4}>
        <Form.Label className="virtual_exchange_information_wallets_text">{props.traductions.VEX.transacciones.L_dateT}:</Form.Label>
        <Form.Control
          type="date"
          
          value={dateTo}
          onChange={(e) => setDateTo(e.target.value) }
        />
      </Col>
      <Col xl={12} style={{marginTop: 10}}>
        <Form.Label>{props.traductions.VEX.transacciones.L_search}</Form.Label>
        <Form.Control className="input-signup" type="text" value={search} onKeyPress={handleKeyPress} onChange={(e) => setSearch(e.target.value)} />
      </Col>
      <div style={{height: "600px", overflowY: "auto", width: "100%"}}>
        <table id="table-transaction" className="table table-borderless" style={{marginTop: '20px', borderCollapse: 'collapse'}}>
          <thead>
            <tr>
              <th className="fixed-header">{props.traductions.VEX.transacciones.T_H_Pair}</th>
              <th className="fixed-header">{props.traductions.VEX.transacciones.T_H_WA}</th>
              <th className="fixed-header">{props.traductions.VEX.transacciones.T_H_category}</th>
              <th className="fixed-header">{props.traductions.VEX.transacciones.T_H_amount}</th>
              <th className="fixed-header">{props.traductions.VEX.transacciones.T_H_Price}</th>
              <th className="fixed-header">{props.traductions.VEX.transacciones.T_H_status}</th>
              <th className="fixed-header">{props.traductions.VEX.transacciones.T_H_date}</th>
            </tr>
          </thead>
          <tbody>
            {renderListTransactions()}
          </tbody>
        </table>
      </div>
    
    </Row>
    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", marginTop: 5, padding: 10 }}>
      <DropdownButton id="select-numberby" title={numberBy}>
        <Dropdown.Item onClick={() => { setNumberBy(25); getTransactions(1, 25, "date_new"); }} as="button">25</Dropdown.Item>
        <Dropdown.Item onClick={() => { setNumberBy(50); getTransactions(1, 50, "date_new"); }} as="button">50</Dropdown.Item>
        <Dropdown.Item onClick={() => { setNumberBy(100); getTransactions(1, 100, "date_new"); }} as="button">100</Dropdown.Item>
      </DropdownButton>
      <Pagination id='custom-pagination'>
        <Pagination.First disabled={currentPage === 1} onClick={() => {
          if (currentPage !== 0) {
            changePage(1);
          }
        }} />
        <Pagination.Prev disabled={currentPage === 1} 
        onClick={() => {if (currentPage !== 0) {
            changePage(currentPage - 1);
          }
        }} />
        {currentPage > 2 && 
          <Pagination.Item 
            
            onClick={() => { changePage(currentPage - 2) }}
          >{currentPage - 2}</Pagination.Item>
        }

        {currentPage > 1 &&
          <Pagination.Item  onClick={() => { changePage(currentPage - 1) }}>{currentPage - 1}</Pagination.Item>
        }
        <Pagination.Item active>{currentPage}</Pagination.Item>
        {currentPage < dataLength &&
          <Pagination.Item  onClick={() => { changePage(currentPage + 1) }}>{currentPage + 1}</Pagination.Item>
        }
        {currentPage < dataLength - 1 &&
          <Pagination.Item  onClick={() => { changePage(currentPage + 2) }}>{currentPage + 2}</Pagination.Item>
        }
        <Pagination.Next disabled={currentPage >= dataLength} onClick={() => {
          if (currentPage < dataLength) {
            this.changePage(currentPage + 1)
          }
        }} />
        <Pagination.Last disabled={currentPage >= dataLength} onClick={() => {
          if (currentPage < dataLength) {
            this.changePage(dataLength)
          }
        }} />
      </Pagination>
    </div>
    </>
  )
}

export default TransactionComponent;